// ThemeContext.js
import { createContext, useState } from 'react';

const data = {
  isAuthenticated: false
  , setIsAuthenticated: () => {
  }
  ,lang: {
    code: 'it'
    ,jsonPath: ''
    ,json :{

    }
  }
  ,setLang: () => {

  }
  , email: ''
  , setEmail: () => {

  }
  , token: {
    access_token: ''
    ,expires_on: ''
  }
  , setToken: () => {

  }
  , password: ''
  , setPassword: () => {

  }
  , stripeSubscription: 
    /*
      standard response from Stripe
      https://stripe.com/docs/api/subscriptions/retrieve
    */
    {
      "id": "sub_1OEtRo2eZvKYlo2CiC2CBHWE",
      "object": "subscription",
      "application": null,
      "application_fee_percent": null,
      "automatic_tax": {
        "enabled": false
      },
      "billing_cycle_anchor": 1701175980,
      "billing_thresholds": null,
      "cancel_at": null,
      "cancel_at_period_end": false,
      "canceled_at": null,
      "cancellation_details": {
        "comment": null,
        "feedback": null,
        "reason": null
      },
      "collection_method": "charge_automatically",
      "created": 1700571180,
      "currency": "usd",
      "current_period_end": 1701175980,
      "current_period_start": 1700571180,
      "customer": "cus_P2zQGlXXlIklIz",
      "days_until_due": null,
      "default_payment_method": null,
      "default_source": null,
      "default_tax_rates": [],
      "description": null,
      "discount": null,
      "ended_at": null,
      "items": {
        "object": "list",
        "data": [
          {
            "id": "si_P2zQBqh0VCbpnK",
            "object": "subscription_item",
            "billing_thresholds": null,
            "created": 1700571181,
            "metadata": {},
            "price": {
              "id": "price_1MmtcK2eZvKYlo2Cr7WFg9JK",
              "object": "price",
              "active": true,
              "billing_scheme": "per_unit",
              "created": 1679122312,
              "currency": "usd",
              "custom_unit_amount": null,
              "livemode": false,
              "lookup_key": null,
              "metadata": {},
              "nickname": null,
              "product": "prod_NXzbn7VQIGBXJf",
              "recurring": {
                "aggregate_usage": null,
                "interval": "month",
                "interval_count": 1,
                "usage_type": "licensed"
              },
              "tax_behavior": "unspecified",
              "tiers_mode": null,
              "transform_quantity": null,
              "type": "recurring",
              "unit_amount": 1500,
              "unit_amount_decimal": "1500"
            },
            "quantity": 1,
            "subscription": "sub_1OEtRo2eZvKYlo2CiC2CBHWE",
            "tax_rates": []
          }
        ],
        "has_more": false,
        "url": "/v1/subscription_items?subscription=sub_1OEtRo2eZvKYlo2CiC2CBHWE"
      },
      "latest_invoice": "in_1OEtRo2eZvKYlo2Ci0YLCvGI",
      "livemode": false,
      "metadata": {},
      "next_pending_invoice_item_invoice": null,
      "on_behalf_of": null,
      "pause_collection": null,
      "payment_settings": {
        "payment_method_options": null,
        "payment_method_types": null,
        "save_default_payment_method": "off"
      },
      "pending_invoice_item_interval": null,
      "pending_setup_intent": "seti_1OEtRo2eZvKYlo2CW9GLoZPK",
      "pending_update": null,
      "schedule": null,
      "start_date": 1700571180,
      "status": "trialing",
      "test_clock": null,
      "transfer_data": null,
      "trial_end": 1701175980,
      "trial_settings": {
        "end_behavior": {
          "missing_payment_method": "create_invoice"
        }
      },
      "trial_start": 1700571180
    }
  , setStripeSubscription: () => { }
  , stripePaymentMethod: {
     /*
      standard response from Stripe
      https://stripe.com/docs/payments/payment-methods
    */
        "id": "pm_123456789",
        "billing_details": {
          "email": "jenny@example.com",
          "name": "Jenny Rosen",
          "phone": "+335555555555"
        },
        "card": {
          "bank_code": "37040044",
          "branch_code": "94832",
          "country": "FR",
          "fingerprint": "ygEJfUjzWMGyWnZg",
          "last4": "3000"
        },
  }
  , setStripePaymentMethod: () => { }
}
// Create a new context
const UserContext = createContext(data);

// Create a custom provider component
function UserProvider({ children }) {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [email, setEmail] = useState('');
  const [lang, setLang] = useState({});
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const [stripeSubscription, setStripeSubscription] = useState({})
  const [stripePaymentMethod, setStripePaymentMethod] = useState({});

  return (
    <UserContext.Provider
      value={{
        isAuthenticated: isAuthenticated
        , setIsAuthenticated: setIsAuthenticated
        , token: token
        , setToken: setToken
        , email: email
        , setEmail: setEmail
        , lang: lang
        , setLang: setLang
        , password: password
        , setPassword: setPassword
        , stripeSubscription: stripeSubscription
        , setStripeSubscription: setStripeSubscription
        , stripePaymentMethod: stripePaymentMethod
        , setStripePaymentMethod: setStripePaymentMethod
      }}>
      {children}
    </UserContext.Provider>
  );
}

export { UserContext, UserProvider };
